import { render, staticRenderFns } from "./ReestrDocSearch.vue?vue&type=template&id=3ed4831c&"
import script from "./ReestrDocSearch.vue?vue&type=script&lang=js&"
export * from "./ReestrDocSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports